import { isDeviceHandheld } from './components/utils'

import '../styles/styles.scss'

class HelioWebComponents {
    constructor() {
        if (!HelioWebComponents.instance) {
            HelioWebComponents.instance = this
        }

        return HelioWebComponents.instance
    }

    init() {
        if (isDeviceHandheld()) document.body.classList.add('mobile')

        this.rippleInit()
        this.galleryInit()
    }

    rippleInit() {
        if (this.elementWithClassExists('js-hel-ripple')) {
            this.importCommands('ripple')
        }
    }

    galleryInit() {
        if (this.elementWithClassExists('js-hel-gallery')) {
            this.importCommands('gallery')
        }
    }

    elementWithClassExists(className) {
        return document.getElementsByClassName(className).length > 0
    }

    importCommands(componentName) {
        return require(`./components/${componentName}/hel-${componentName}.js`)
    }
}

const instance = new HelioWebComponents()
Object.freeze(instance)

export default instance
